import React from 'react'
import Otherspage from '../components/Otherspage/Otherspage'

function Others() {
  return (
    <div> 
      <Otherspage/>   

      
    </div>
  )
}

export default Others
